import { IconContainer } from '@/components/IconWithHover';
import checkedBoxOutlined from '@/images/Checkbox.svg';
import checkedBox from '@/images/CheckboxBlack.svg';
import styled from '@emotion/styled';
import { MouseEvent } from 'react';

const EmptyBox = styled.span<{ checked?: boolean; size?: string }>`
    display: ${({ checked }) => (checked ? 'none' : 'block')};
    height: ${({ size }) => size || '20px'};
    width: ${({ size }) => size || '20px'};
    border-radius: 4px;
    border: 1px solid var(--secondary-shades-500, #82807e);
    cursor: pointer;
    padding: 4px;
`;

const StyledIconContainer = styled(IconContainer)<{ disableHover?: boolean }>`
    ${({ disableHover }) =>
        disableHover &&
        `
    &:hover {
        background: transparent;
    }`}
`;

interface Props {
    checked: boolean;
    onClick?: (event: MouseEvent) => void;
    disabled?: boolean;
    outlined?: boolean;
    disableHover?: boolean;
    testId?: string;
    size?: string;
}

export default function Checkbox({ checked, size, onClick, disabled, outlined, disableHover, testId }: Props) {
    const checkedSrc = outlined ? checkedBoxOutlined : checkedBox;

    return (
        <StyledIconContainer onClick={onClick} disabled={disabled} disableHover={disableHover} data-testid={testId}>
            {/* Rendering both icons in order to prevent a jump on first loading of checked icon */}
            <img src={checkedSrc} alt="checkbox" style={{ display: checked ? 'block' : 'none', height: size, width: size }} />
            <EmptyBox checked={checked} size={size} />
        </StyledIconContainer>
    );
}
